export default __webpack_public_path__ + "assets/vistoo-logo.d30db8af.png";